import type { ReactNode } from 'react';
import { EspacoDeAnuncio } from './EspacoDeAnuncio';

/** O cartão de anúncio entra depois deste produto, e só se a lista tiver pelo menos isso. */
export const ANUNCIO_DEPOIS_DO = 6;

/**
 * Os cartões do catálogo com o anúncio da loja gratuita intercalado (uma vez,
 * depois do 6º). Sem anúncio para a loja, o espaço não desenha nada e a grade
 * fica igual.
 */
export function comAnuncioNoCatalogo(cartoes: ReactNode[]): ReactNode[] {
  if (cartoes.length < ANUNCIO_DEPOIS_DO) return cartoes;
  return [
    ...cartoes.slice(0, ANUNCIO_DEPOIS_DO),
    <EspacoDeAnuncio key="anuncio-no-catalogo" posicao="IN_FEED" className="h-full" />,
    ...cartoes.slice(ANUNCIO_DEPOIS_DO),
  ];
}
